"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenStateSerializer = exports.TokenState = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var TokenState;
(function (TokenState) {
    TokenState[TokenState["Uninitialized"] = 0] = "Uninitialized";
    TokenState[TokenState["Initialized"] = 1] = "Initialized";
    TokenState[TokenState["Frozen"] = 2] = "Frozen";
})(TokenState = exports.TokenState || (exports.TokenState = {}));
function getTokenStateSerializer() {
    return (0, serializers_1.scalarEnum)(TokenState, {
        description: 'TokenState',
    });
}
exports.getTokenStateSerializer = getTokenStateSerializer;
//# sourceMappingURL=tokenState.js.map